import { render } from "./myFilesDialog.vue?vue&type=template&id=3d1c2119&scoped=true"
import script from "./myFilesDialog.vue?vue&type=script&lang=js"
export * from "./myFilesDialog.vue?vue&type=script&lang=js"

import "./myFilesDialog.vue?vue&type=style&index=0&id=3d1c2119&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3d1c2119"]])

export default __exports__